/* RESPONSIBLE TEAM: team-standalone */
/* eslint-disable @intercom/intercom/no-bare-strings */

import { type InterfaceIconName } from '@intercom/pulse/lib/interface-icons';

/**
 * Available platforms for generic handoff operations (external tickets, agents, etc.)
 */
export const AVAILABLE_HANDOFF_PLATFORMS = ['zendesk', 'hubspot', 'freshdesk'] as const;

export type HandoffPlatform = (typeof AVAILABLE_HANDOFF_PLATFORMS)[number];

export const HANDOFF_PLATFORM_ICONS: Record<HandoffPlatform, InterfaceIconName> = {
  zendesk: 'zendesk',
  hubspot: 'hubspot',
  freshdesk: 'ticket',
};

export function getHandoffPlatformsForApp(app: { canUseFeature(feature: string): boolean }) {
  return AVAILABLE_HANDOFF_PLATFORMS.filter((platform) => {
    let featureFlag = `team-standalone-external-ticket-handoff-${platform}`;
    return app.canUseFeature(featureFlag);
  });
}

/**
 * Mapping of platform types to their display names
 */
export const HANDOFF_PLATFORM_DISPLAY_NAMES: Record<HandoffPlatform, string> = {
  zendesk: 'Zendesk',
  hubspot: 'HubSpot',
  freshdesk: 'Freshdesk',
};

/**
 * Mapping of platform types to their sidesheet component names
 */
export const HANDOFF_PLATFORM_COMPONENTS: Record<HandoffPlatform, string> = {
  zendesk: 'standalone/external-ticket-handoff-steps/zendesk',
  hubspot: 'standalone/external-ticket-handoff-steps/hubspot',
  freshdesk: 'standalone/external-ticket-handoff-steps/freshdesk',
} as const;
